module.exports = __webpack_public_path__ + "static/don14-496bc568aaaffc52945ab13f121c6271.jpg";